import {
  Dialog,
  DialogContent,
  DialogHeader,
} from "~/components/ui/dialog";
import { Drawer, DrawerClose, DrawerContent, DrawerHeader } from "~/components/ui/custom-bottom-drawer";
import { X } from "lucide-react";
import Cookies from "js-cookie";
import ReactPlayer from "react-player";

export default function MediaModal({
  setVisible,
  media,
}: {
  setVisible: (open: boolean) => void;
  media: any | null;
}) {
  const isClient = typeof window !== "undefined";
  const screenWidth = isClient
    ? parseInt(Cookies.get("screenWidth") || "0", 10)
    : 1024;
  const isMobile = screenWidth > 0 && screenWidth < 768;

  if (!media) return null;

  const content = (
    <>
      {media.type === "Video" ? (
        <div className="rounded-lg overflow-hidden">
          <ReactPlayer
            style={{ borderRadius: 24 }}
            autoPlay
            height={isMobile ? 240 : 400}
            width={isMobile ? "100%" : 600}
            src={media.url}
            controls
          />
        </div>
      ) : (
        <div className="bg-cyan-50 flex flex-col justify-center items-center rounded-lg overflow-hidden w-full md:w-[600px]">
          <img
            src={`https://ik.imagekit.io/officehub/tr:h-480,fo-auto,f-avif/${media.thumbnail}`}
            className="w-full"
            alt={media.title}
          />
          <p className="p-4 text-xs border-b w-full">{media.description}</p>
          <audio
            autoPlay
            controls
            className="w-full rounded-none no-radius-audio p-2 bg-[#f1f3f4]"
          >
            <source src={media.url} type="audio/wav" />
          </audio>
        </div>
      )}
    </>
  );

  return isMobile ? (
    <Drawer open onOpenChange={setVisible}>
      <DrawerContent className="p-4">
        <div className="mb-2 flex items-center justify-between">
          <div className="text-center font-semibold text-base flex-1">
            {media.title}
          </div>

        </div>
        {content}</DrawerContent>
    </Drawer>
  ) : (
    <Dialog open onOpenChange={setVisible}>
      <DialogContent className="bg-transparent border-none shadow-none rounded-lg p-0 max-w-fit flex flex-col justify-center items-center">
        <DialogHeader>
          <div className="h-10" />
        </DialogHeader>
        {content}
      </DialogContent>
    </Dialog>
  );
}
